import './App.css';
import Grid from '@mui/material/Grid';
import Navbar from './components/Layouts/Navbar/Navbar';
import { createTheme } from '@mui/material/styles';
import { ThemeProvider } from '@emotion/react';
import Home from './components/Home/Home';
import About from './components/About/About';
import Portfolio from './components/Portfolio/Portfolio';
import Service from './components/Service/Service';
import ParticlesBG from './components/Particles/ParticlesBG';
import Testimonial from './components/Testimonial/Testimonial';
import Contact from './components/Contact/Contact';
import Footer from './components/Layouts/Footer/Footer';
import TechStack from './components/TechStack/TechStack';
import { useScroll, useSpring, motion } from 'framer-motion';
import { useContext } from 'react';
import { ThemeContext } from './components/Context/ThemeContext';
import { blue, deepOrange } from '@mui/material/colors';

function App() {
  const {mode} = useContext(ThemeContext);
  console.log(mode);
  const theme = createTheme({
    typography: {
        fontFamily: "'Quicksand', sans-serif", 
        h3: {
          '@media (max-width:600px)': {
            fontSize: '1.8rem',
          },
        }
    },
    palette: {
      mode: mode ? "dark" : "light",
      primary: {
        main: "#42446E",
        ...(mode && {
          main: blue["300"],
        secondary: "#42446E",
        })
      }
    }
  });

  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });

  return (
    <ThemeProvider theme={theme}>
      <Grid container direction={"column"}
        sx={{
          color: 'text.primary',
        }}
      >
      <motion.div className="progress-bar" style={{ scaleX }} />
        <Grid item xs={12}>
          <ParticlesBG />
          <Navbar />
        </Grid>
        <Grid item xs={12}>
          <Home />
          <About />
          <Portfolio />
          <Service />
          <Testimonial />
          <TechStack />
          <Contact />
          <Footer />
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}

export default App;
